import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Navbar({ variant = 'transparent' }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    // If we're on a different page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToHome = (e) => {
    e.preventDefault();
    // If we're on a different page, navigate to home
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      // If already on home, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    // If we're on a different page, navigate to home
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      // If already on home, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar navbar-${variant}`} id="navbar">
      <div className="container nav-container">
        <div className="nav-logos-combined" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <div className="logo">
            <img src="/logo-brain-event.png" alt="Brain Event" className="logo-img logo-default" />
            <img src="/logo-brain-event-white.png" alt="Brain Event" className="logo-img logo-white" />
          </div>
          <span className="logo-separator nav-separator">×</span>
          <div className="logo logo-neuros-nav">
            <img src="/assets/logo-on-black.webp" alt="Neuros" className="logo-img-neuros-nav" />
          </div>
        </div>

        {/* Navigation Menu */}
        <div className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
          <a href="/" className="nav-link" onClick={scrollToHome}>Home</a>
          <a href="#speakeri" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('speakeri'); }}>Speakeri</a>
          <a href="#pachete" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('pachete'); }}>Pachete</a>
          <a href="#faq" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>FAQ</a>
          <a href="https://my.brain-event.com/login" className="nav-link nav-link-mobile-only">Login</a>
        </div>
        
        <div className="nav-right">
          <div className="nav-badge">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M11 1V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M5 1V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M2 5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <span>20 iunie 2026 • București</span>
          </div>
          <a href="https://my.brain-event.com/login" className="btn btn-outline btn-nav" style={{marginRight: '10px'}}>Login</a>
          <a href="https://my.brain-event.com" className="btn btn-primary btn-nav">Rezervă-ți locul</a>

          {/* Mobile Menu Toggle */}
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
            <span className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;




